export default __webpack_public_path__ + "static/space-003129a54336169e59172384de2c81ce.jpg";